import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Route, IndexRoute } from 'react-router'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import configureStore from './stores'
import App from './containers/App'
import Types from './containers/Types'
import Projects from './containers/Projects'
import Segments from './containers/Segments'
import Headers from './containers/Headers'
import Reports from './containers/Reports'
import './index.styl'

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)

render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={App}>
        <IndexRoute component={Types} />
        <Route path="/projects" component={Projects} />
        <Route path="/headers" component={Headers} />
        <Route path="/segments" component={Segments} />
        <Route path="/saved-reports" component={Reports} />
      </Route>
    </Router>
  </Provider>,
  document.getElementById('app')
)



// WEBPACK FOOTER //
// ./index.js